import { ColumnDef } from '@tanstack/react-table';
import { ReactElement } from 'react';

import { InventoryRequest } from 'app/graphql/generated/admin/graphql';
import { CopyId } from 'components/ui/copy-id';
import { Timestamp } from 'components/ui/timestamp';

const renderRequestedData = (url: string): string | ReactElement => {
  try {
    const parsed = new URL(url).toString();
    return (
      <a
        href={parsed}
        target="_blank"
        rel="noopener noreferrer"
        className="break-all underline underline-offset-2"
      >
        {parsed}
      </a>
    );
  } catch {
    return url;
  }
};

export const columns: ColumnDef<InventoryRequest>[] = [
  {
    accessorKey: 'id',
    header: 'Request ID',
    cell: ({ row }) => <CopyId value={row.original.id} />,
  },
  {
    accessorKey: 'requestedAt',
    header: 'Date',
    cell: ({ row }) => <Timestamp date={row.original.requestedAt} />,
    meta: { cellClassName: 'whitespace-nowrap' },
  },
  {
    accessorKey: 'requestType',
    header: 'Request Type',
    meta: { cellClassName: 'whitespace-nowrap' },
  },
  {
    accessorKey: 'data',
    header: 'Requested Data',
    cell: ({ row }) => renderRequestedData(row.original.data),
    meta: { cellClassName: 'break-all' },
  },
];
